import './index.less';

export default function LoadingFallback() {
  return (
    <div className="ant-spin-container" data-testid="loading-fallback">
      <div className="ant-spin ant-spin-lg ant-spin-spinning">
        <span className="ant-spin-dot ant-spin-dot-spin">
          <i className="ant-spin-dot-item"></i>
          <i className="ant-spin-dot-item"></i>
          <i className="ant-spin-dot-item"></i>
          <i className="ant-spin-dot-item"></i>
        </span>
      </div>
    </div>
  );
}
